import { ApiProperty } from '@nestjs/swagger';
import { IsOptional } from 'class-validator';

import { SpConnectBuilderTotalQuantityInterface } from '../interfaces/sp-connect-builder-total-quantity.interface';

export class SpConnectBuilderTotalQuanityDto
  implements SpConnectBuilderTotalQuantityInterface
{
  @ApiProperty()
  @IsOptional()
  quantityOrdered?: number;
}
